import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CALENDLY_COST_REVIEW_URL } from "@/lib/urls";

const DEFAULT_TRUST_POINTS = [
  "Read-only AWS access",
  "Report ready to hand to your team",
  "No commitment",
] as const;

interface ServiceCallToActionProps {
  heading?: string;
  subheading?: string;
  trustPoints?: readonly string[];
}

export function ServiceCallToAction({
  heading = "Ready to find out what you're overspending on?",
  subheading = "Book a free call to discuss your AWS environment. We'll scope the work and get started.",
  trustPoints = DEFAULT_TRUST_POINTS,
}: ServiceCallToActionProps): React.ReactElement {
  return (
    <section className="py-24 bg-primary text-primary-foreground -mx-4">
      <div className="max-w-4xl mx-auto text-center px-4">
        <h2 className="text-4xl font-bold mb-6">{heading}</h2>
        <p className="text-xl text-primary-foreground/80 mb-8">{subheading}</p>
        <Button asChild size="xl" className="bg-white text-primary font-semibold hover:bg-white/90">
          <a
            href={CALENDLY_COST_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Book a free call
          </a>
        </Button>
        <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-4">
          {trustPoints.map((point) => (
            <li key={point} className="flex items-center gap-1.5 text-sm text-primary-foreground/70">
              <CheckCircle className="size-3.5 text-primary-foreground/70 flex-none" />
              {point}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
